module.exports = __webpack_public_path__ + "static/media/ophos-server.a988d16a.svg";